import { useState, type FocusEvent, type MouseEvent } from 'react'
import { approvalKeyOf } from '@/app/document-review/approval-row'

export function useActiveApprovalKey() {
  const [focusedKey, setFocusedKey] = useState<string | null>(null)
  const [hoveredKey, setHoveredKey] = useState<string | null>(null)
  const [movedLast, setMovedLast] = useState<'focus' | 'pointer'>('focus')

  const onFocus = (event: FocusEvent<HTMLElement>) => {
    const key = approvalKeyOf(event.target)
    if (key === focusedKey) return
    setFocusedKey(key)
    setMovedLast('focus')
  }

  const onMouseOver = (event: MouseEvent<HTMLElement>) => {
    const key = approvalKeyOf(event.target)
    if (key === hoveredKey) return
    setHoveredKey(key)
    setMovedLast('pointer')
  }

  const activeKey = movedLast === 'pointer' ? (hoveredKey ?? focusedKey) : (focusedKey ?? hoveredKey)

  return {
    activeKey,
    onFocus,
    onBlur: () => setFocusedKey(null),
    onMouseOver,
    onMouseLeave: () => setHoveredKey(null)
  }
}
